import { render } from "./checkbox.vue?vue&type=template&id=0d52ed4e&ts=true"
import script from "./checkbox.vue?vue&type=script&lang=ts"
export * from "./checkbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__